export default __webpack_public_path__ + "static/logo-876979c039b13a9919e0d27d4cfbf651.svg";